import React from 'react';
import { DropDownMenu, Option, Text, TextType, useIsTouchableDevice } from '@philips-internal/oswald-ui-components';
import { classNames } from '@philips-internal/oswald-ui-utils';
import { getRouteLevel } from '../../../util/index.js';
import './auxiliary-bar.css';
function AuxiliaryBar(props) {
    const isTouchableDevice = useIsTouchableDevice();
    if (isTouchableDevice) {
        return null;
    }
    const auxiliaryBarClassName = classNames({
        'c-auxiliary-bar': true,
        [`${props.className}`]: Boolean(props.className),
    });
    const returnToTheBeginning = getRouteLevel(props.route.id) > 2 ? (React.createElement(Option, { onClick: props.onReturnClick, preventDefault: true, stopPropagation: false, value: "tws.application-bar.return-to-the-beginning" })) : null;
    return (React.createElement("div", { className: auxiliaryBarClassName },
        React.createElement("div", { className: "c-auxiliary-bar__route" },
            React.createElement(DropDownMenu, { uuid: "auxiliary-uuid" },
                React.createElement("div", { slot: "header" },
                    React.createElement(Text, { type: TextType.SECONDARY, value: props.route.name })),
                React.createElement("div", { slot: "content" },
                    props.routes.map((item) => {
                        const { id, name } = item;
                        return (React.createElement(Option, { key: id, onClick: () => props.onClick(item, props.route.id), preventDefault: true, stopPropagation: false, value: name }));
                    }),
                    returnToTheBeginning)))));
}
export { AuxiliaryBar, };
//# sourceMappingURL=auxiliary-bar.js.map